var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fadeout","mode":"out-in"}},[(_vm.hasSections)?_c('full-page',{ref:"fullpage",attrs:{"options":_vm.fullPageOptions,"id":"fullpage"}},[_c('ActualContent')],1):_c('ActualContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }